import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  /**
   * Своя замена упавшему разделу вместо экрана «Интерфейс упал». Для
   * второстепенных разделов: сбой пробы predict.fun не вправе размонтировать
   * страницу, с которой торгуют Polymarket.
   */
  fallback?: ((error: Error) => ReactNode) | undefined;
}

interface State {
  error: Error | null;
}

/**
 * Последний рубеж рендера: без него одно битое событие из шины размонтирует
 * всё дерево, и торговый терминал превращается в белый экран до ручной
 * перезагрузки. Ловим ошибку, показываем её и даём переоткрыть приложение.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error): void {
    console.error("необработанная ошибка рендера", error);
  }

  render(): ReactNode {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(this.state.error);

    return (
      <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8">
        <h1 className="text-lg font-semibold">Интерфейс упал</h1>
        <p className="max-w-lg break-all text-center text-sm text-[var(--color-muted)]">
          {this.state.error.message}
        </p>
        <button
          onClick={() => location.reload()}
          className="rounded border border-[var(--color-border)] px-4 py-1.5 text-sm hover:text-white"
        >
          перезагрузить
        </button>
      </div>
    );
  }
}
